/**
 * @description 预估列表
 *
 * @props tabList 表格数据
 * @props transportOption 物流方式下拉数据
 */
<template>
    <div>
        <gj-table
            ref="gjTable"
            size='has-picture'
            name="flag"
            :index="false"
            selection
            :data="tableData"
            :columns="columns"
            :loading="loading"
            :adapt-height="false"
            :height="250"
            @selection-change="handleSelectionChange"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
            <!-- 物流方式 -->
            <template v-slot:transportId="{ row }">
                <gj-select
                    :options="transportOption"
                    v-model="row.transportIdPrescriptionId"
                    @change="changeE(row)"
                    :clearable="false"
                ></gj-select>
            </template>
            <!-- 补货数量 -->
            <template v-slot:makeGoodQuantity="{ row }">
                <gj-input
                    v-checkInteger:makeGoodQuantity="{value: row.makeGoodQuantity, obj: row}"
                    v-model="row.makeGoodQuantity"
                    @change="change(row)"
                    :clearable="false"
                    maxlength="8"
                    placeholder="请输入"
                ></gj-input>
            </template>
            <!-- 下单日期 -->
            <template v-slot:underOrderDate="{ row }">
                <el-date-picker
                    v-model="row.underOrderDate"
                    :clearable="false"
                    type="date"
                    size="small"
                    @change="changeE(row)"
                    placeholder="选择日期">
                </el-date-picker>
            </template>
        </gj-table>
        <div class="add">
            <gj-button type="danger" plain @click="deleteList">删除</gj-button>
            <gj-button type="primary" @click="addEstimateEven">添加预估</gj-button>
        </div>
    </div>
</template>

<script>
import addEstimate from "./add-estimate.vue";
import { convertToDate } from "@/utils/date.util.js"
import {isMeaningfulMixin, queryMixin, selectionMixin} from "@/minxins";
import { storageAnalysisListEstimate, storageAnalysisDelEstimate, storageAnalysisAddEstimate } from "@/api/statistics";

export default {
    mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
    inject: ['getPageParams', 'generatorPageParams'],
    computed: {
        pageParams () {
            return this.getPageParams()
        },
    },
    directives: {
        // 控制只能输入整数
        checkInteger: {
            update: (el, binding) => {
                let params = binding.value
                const regexp = (/[^0-9]|^0+(?!$)/g);
                if (!params || !params.value) { return }
                if (regexp.test(params.value)) {
                    params.obj[binding.arg] = params.value.replace(regexp, "");
                }
            }
        }
    },
    props: {
        tabList: {
            type: Array,
            default: () => []
        },
        transportOption: {
            type: Array,
            default: () => []
        },
        storageAnalysisGetSmart: {
            type: Object,
            default: () => ({})
        },
        dataZoomMap: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            tableData: [],
            columns: [
                {id: 'marketId', header: '店铺', field: 'marketName', minWidth: '90px', default: true},
                {id: 'transportId', header: '物流方式', field: 'slot:transportId', minWidth: '120px', default: true},
                {id: 'makeGoodQuantity', header: '数量', field: 'slot:makeGoodQuantity', minWidth: '90px', default: true},
                {id: 'underOrderDate', header: '调拨/下单日期', field: 'slot:underOrderDate', minWidth: '144px', default: true},
                {id: 'expectInboundDate', header: '预计入库时间', field: 'expectInboundDate', minWidth: '100px', default: true},
            ],
            loading: false,
        }
    },
    methods: {
        // 更新预估
        async storageAnalysisAddEstimate(row) {
            let res = await storageAnalysisAddEstimate(this.structureParams(row))
        },
        // 构造更新预估params
        structureParams(row) {
            let params = {
                asinCode: this.pageParams.asinCode, //ASIN类型值
                asinType: this.pageParams.asinType, //ASIN类型（子asin：child，父asin：parent）
                addList: []
            }
            let split = row.transportIdPrescriptionId.split("#")
            let elment = {
                id: row.id,
                expectInboundDate: convertToDate(row.expectInboundDate),
                lackGoodDate: row.lackGoodDate,
                lackGoodDay: row.lackGoodDay,
                makeGoodQuantity: row.makeGoodQuantity,
                marketId: row.marketId,
                prescriptionId: split[1],
                transportId: split[0],
                underOrderDate: convertToDate(row.underOrderDate)
            }
            params.addList.push(elment)
            return params
        },
        change(row) {
            this.storageAnalysisAddEstimate(row)
            this.$emit("estimateChange") // 修改红绿线
        },
        changeE(row) {
            let logisticsDays = 0
            for (const iterator of this.transportOption) {
                if (row.transportIdPrescriptionId == iterator.id) {
                logisticsDays = iterator.text.split("-")[1]
                logisticsDays = logisticsDays.substr(0,logisticsDays.length-1)
                }
            }
            let day = Number(logisticsDays) + Number(this.storageAnalysisGetSmart.purchaseDeliveryDays)
            let time = 86400000*day
            let time1 = new Date(row.underOrderDate).getTime()
            row.expectInboundDate = convertToDate(time + time1)
            this.storageAnalysisAddEstimate(row)
            this.$emit("estimateChange") // 修改红绿线
        },
        // 监听勾选事件改变折线图
        handleSelectionChange(val) {
            this.$emit("handleSelectionChange", val)
        },
        // 删除预估
        async deleteList() {
            if (this.selectedRows.length == 0) {
                this.$gjMessage.error('请先勾选要删除的预估');
                return;
            }
            this.loading = true
            let params = this.selectedRows.reduce((arr, item) => arr.concat(item.id), [])
            let res = await storageAnalysisDelEstimate(params)
            this.storageAnalysisListEstimate()
        },
        // 添加预估
        addEstimateEven() {
            this.$gjCreate(addEstimate, {
                props: {
                    tabList: this.tabList,
                    transportOption: this.transportOption,
                    storageAnalysisGetSmart: this.storageAnalysisGetSmart,
                    pageParams: this.pageParams,
                    dataZoomMap: this.dataZoomMap
                },
                on: {
                    created: () => {
                        this.$gjResetPage();
                    },
                    storageAnalysisListEstimate: () => {
                        this.storageAnalysisListEstimate()
                    } 
                }
            });
        },
        // 查询预估list
        async storageAnalysisListEstimate() {
            this.loading = true
            let params = {
                asinCode: this.pageParams.asinCode,
                asinType: this.pageParams.asinType
            }
            let res = await storageAnalysisListEstimate(params)
            this.tableData = res || []
            for (const i of this.tableData) {
                i.transportIdPrescriptionId = `${i.transportId}#${i.prescriptionId}`
            }
            this.loading = false
        },
    },
    created() {
        this.storageAnalysisListEstimate()
    }
}
</script>

<style scoped lang="scss">
  /deep/.el-date-editor {
    width: 100% !important;
  }
  /deep/.el-select {
    width: 100% !important;
  }
  /deep/.gj-prefix-center {
      &.el-input {
          width: 100% !important;
      }
  }
.add {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}
</style>